import { useTheme } from '@emotion/react';
import { CancelToken } from 'apisauce';
import React from 'react';
import { useState } from 'react';
import appapi from '../../../../api/apiClient';
import Layout from '../../../../components/Layout';
import { Box, Stack, TablePagination, Typography } from '@mui/material';
import PageHeader from '../../../../components/PageHeader';
import Datatable from '../../../../components/DataTable';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import { useEffect } from 'react';

export default function CompanyList({ traderId }) {
  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '10%',
    },
    {
      id: 1,
      header: 'Company Name',
      accessor: 'companyName',
      width: '40%',
      search: false,
      capitalize: true,
    },
    {
      id: 2,
      header: 'Company Type',
      accessor: 'companyType',
      width: '25%',
      capitalize: true,
    },
    {
      id: 3,
      header: 'Location',
      width: '25%',
      capitalize: true,
      Cell: (value) => (
        <Stack
          direction="row"
          justifyContent="center"
        >
          <Typography className="fs-12 ff-Roboto fw-regular !capitalize">
            {value.stateName},{value.countryName}
          </Typography>
        </Stack>
      ),
    },
  ];

  const theme = useTheme();
  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    status: 0,
    sortOrder: 'desc',
  });
  let source = CancelToken.source();
  const [type, setType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetCompanyList = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/trader/traderVsCompany/${traderId}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        status: payload.status,
        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response?.companies;
        userData?.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setCompanyList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.count, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setCompanyList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0,  paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setCompanyList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0,  paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetCompanyList();
    return () => {
      if(source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.status, payload.field, payload.sortOrder]);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems={'inherit'}
        className="w-[100%] pr-[20px]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <Stack className="w-[100%]">
          <PageHeader
            headerTittle={`Trader`}
            handleOnSearchEmit={(search) => {
              handleSearchEmit(search);
            }}
            placeholder={'Company Name'}
            userPermission={''}
            handleExcelDownloadEmit={(value) => {}}
            searchBarWidth={'180px'}
          />
        </Stack>
        <Stack style={{ backgroundColor: '#FFFFFF' }}>
          <TablePagination
            rowsPerPageOptions={[]}
            count={payload.totalLength ? payload.totalLength : 0}
            rowsPerPage={payload.limit ? payload.limit : 10}
            page={payload.paginationPage ? payload.paginationPage : 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Stack>
      </Stack>
      <Box sx={{ width: '100%' }}>
        <Datatable
          data={companyList || []}
          columns={columns}
          isLoading={isLoading}
        />
      </Box>
    </>
  );
}
